import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IColunaBotoes } from '../../interface/icm-botoes-generico';
import { IRetornoBotao } from '../../interface/icm-retorno-botao';

@Component({
    selector: 'icm-coluna-botoes',
    templateUrl: './view/icm-coluna-botoes.component.html',
    styleUrls: ['./view/icm-coluna-botoes.component.scss'],
})
export class IcmColunaBotoesComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaBotoes;
    @Input() carregando: boolean;

    @Output() expandirClicado = new EventEmitter<IRetornoBotao<any>>();

    exibeBotoes: boolean;

    constructor() {}

    ngOnInit(): void {
        this.exibeBotoes = this.coluna.lista.some((botao) =>
            botao?.exibirSe ? botao.exibirSe(this.linha) : true
        );
    }
}
